import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderNudgeComponent } from './header-nudge.component';



@NgModule({
  declarations: [
    HeaderNudgeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HeaderNudgeComponent
  ]
})
export class HeaderNudgeModule { }
